export default __webpack_public_path__ + "static/media/icon_map.f60ae81e.svg";